const Logo = () => {
  return (
    <div className="mr-auto md:w-48 flex-shrink-0">
      <img className="h-16 md:h-10" src="/assets/logo.png" alt="" />
    </div>
  );
};

export default Logo;
